import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgBritishFlagBlackAndWhite = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("rect", {
    x: -0.001,
    y: 4.003,
    width: 24,
    height: 16,
    rx: 1.714,
    fill: "#fff"
  }), _jsx("mask", {
    id: "british-flag-black-and-white_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 4,
    width: 25,
    height: 17,
    children: _jsx("rect", {
      x: -0.001,
      y: 4.003,
      width: 24,
      height: 16,
      rx: 1.714,
      fill: "#fff"
    })
  }), _jsxs("g", {
    mask: "url(#british-flag-black-and-white_svg__a)",
    children: [_jsx("path", {
      fill: "#232323",
      d: "M-.001 4.003h24v16.134h-24z"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M-1.1 2.457 9.142 8.96V2.928h5.715v6.031l10.242-6.502 1.278 1.784-8.098 5.14H24v5.379h-5.72l8.098 5.14-1.278 1.784-10.242-6.502v6.031H9.142v-6.031L-1.1 21.684-2.378 19.9l8.098-5.14H0V9.382h5.72L-2.378 4.24-1.1 2.457Z",
      fill: "#fff"
    }), _jsx("path", {
      d: "M16 9.112 26.856 2.39M17.153 15.054l9.732 6.173M6.861 9.094-3.29 2.655M7.962 14.979-3.29 22.002",
      stroke: "#5A5A5A",
      strokeWidth: 0.571,
      strokeLinecap: "round"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M-.001 13.684h10.286v6.454h3.428v-6.454H24v-3.227H13.713V4.003h-3.428v6.454H-.001v3.227Z",
      fill: "#636363"
    })]
  })]
}));
export default SvgBritishFlagBlackAndWhite;